export interface UploadImage {
  fileName: string
  url: string
}

export function UploadImageFromJSON(json: any): UploadImage {
  if (json === undefined || json === null) {
    return json
  }
  return {
    fileName: json.file_name,
    url: json.url
  }
}
